import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";

import Button from "@material-ui/core/Button";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import ReactHtmlParser from "react-html-parser";
import Common from "./../../common.json";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  space: {
    // height: 100,
  },
  appContent: {
    padding: 40,
    paddingBlock: 50,
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HowToUse() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [globaldata, setglobaldata] = useState({});
  const [subject, setSubject] = useState();
  const [content, setcontent] = useState();

  useEffect(() => {
    setLoading(true);
    RestService.getHowToUseData(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setglobaldata(response.data);
    });
  }, []);

  const gettutorialData = (id) => {
    setLoading(true);
    RestService.getHowToUseDetailsData(function (res) {
      setLoading(false);
      const response = JSON.parse(res);
      setSubject(response.data.getResult[0].subject);
      setcontent(response.data.getResult[0].content);
    }, id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const classes = useStyles();

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet {...Common?.howToUse} />

      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="How To Use" />
          <div className="row">
            <div className="col-md-12">
              <h1 className="highlighttext">How to use</h1>
              <p>
              Learn how to choose stocks for intraday, how to use money tree robo app. Learn how the stock market works? Explore frequently asked questions about money tree robo. Find the uniqueness of the money tree robo. 
              </p>
            </div>
          </div>
          <div className="signalheader">
            <div className="news-original">
              <div className="row">
                {globaldata.tutorial
                  ? globaldata.tutorial.map((item, key) => (
                      <div className="col-md-3 mt-4" key={key}>
                        <div className="card profile-card-5">
                          <div className="card-body pt-3">
                            <h5
                              className={
                                classes.space + " card-title htu-title pt-2"
                              }
                            >
                              {item.subject}{" "}
                            </h5>
                            <button
                              onClick={(event) => gettutorialData(item.id)}
                              className="btn btn-block btn-primary"
                              variant="outlined"
                              color="primary"
                            >
                              Know More
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {subject ? subject : ""}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Close
            </Button>
          </Toolbar>
        </AppBar>
        <div className={classes.appContent}>
          {content ? ReactHtmlParser(content) : ""}
        </div>
      </Dialog>
    </>
  );
}
